import React from "react";
import PhoneNumberInput from "../../PhoneNumberInput";
import InputComponentV2 from "../../InputComponentV2";
import DropDownComponentV2 from "../../DropDownComponentV2";
import DropDownComponentSortedV2 from "../../DropDownComponentSortedV2";
import TextFieldComponentV2Mobile from "../../TextFieldComponentV2Mobile";

function GeneralInformationV2EmergencySection(props) {
  const {
    translate,
    emergencyContactFirstName,
    handleEmergencyContactFirstNameChange,
    emergencyContactLastName,
    handleEmergencyContactLastNameChange,
    emergencyContactRelationship,
    handleEmergencyContactRelationshipChange,
    emergencyRelationshipOther,
    handleEmergencyRelationshipOther,
    emergencyContactPhoneNumber,
    handleEmergencyContactPhoneNumberChange,
    emergencyContactEmail,
    handleEmergencyContactEmailChange,
    emergencyContactAddress,
    handleEmergencyContactAddressChange,
    emergencyContactCity,
    handleEmergencyContactCityChange,
    emergencyContactNationality,
    handleEmergencyContactNationalityChange,
    provinceEmergencyContact,
    handleProvinceEmergencyContactChange,
    emergencyContactCountry,
    handleEmergencyContactCountryChange,
    payerName,
    handlePayerNameChange,
    payerPhoneNumber,
    handlePayerPhoneNumberChange,
  } = props;

  return (
    <div style={{ width: "100%", marginLeft: "0px" }}>
      <div style={{ paddingBottom: "25px", borderTop: "1px solid red", paddingTop: "10px" }}>
        <span id="emergency-contact" style={{ fontSize: "14px", fontWeight: "600", color: "red", paddingLeft: "10px" }}>{translate("EmergencyContact")}</span>
      </div>
      <div style={{ display: "flex", flexDirection: "row", flexWrap: "wrap", paddingLeft: "10px", gap: "10px" }}>
        <InputComponentV2 title={translate("EmergencyContactFirstName")} width="95%" value={emergencyContactFirstName} onChange={handleEmergencyContactFirstNameChange} />
        <InputComponentV2 title={translate("EmergencyContactLastName")} width="95%" value={emergencyContactLastName} onChange={handleEmergencyContactLastNameChange} />
        <DropDownComponentSortedV2 api="relationship" title={translate("Relationship")} width="95%" value={emergencyContactRelationship} onChange={handleEmergencyContactRelationshipChange} />
        {emergencyContactRelationship === "Other" ? <InputComponentV2 title={translate("IfOtherDescribe")} width="250px" value={emergencyRelationshipOther} onChange={handleEmergencyRelationshipOther} /> : ""}
        <div style={{ width: "50%" }}>
          <PhoneNumberInput title={translate("ContactPhoneNumber")} value={emergencyContactPhoneNumber} onChange={handleEmergencyContactPhoneNumberChange} />
        </div>
        <div style={{ width: "50%" }}>
          <InputComponentV2 title={translate("ContactEmail")} width="250px" value={emergencyContactEmail} onChange={handleEmergencyContactEmailChange} />
        </div>
      </div>
      <div style={{ width: "100%", display: "flex", flexDirection: "row", marginTop: "20px", paddingLeft: "10px" }}>
        <TextFieldComponentV2Mobile title={translate("PhysicalAddressOfResidence")} value={emergencyContactAddress} onChange={handleEmergencyContactAddressChange} width="100%" />
      </div>
      <div style={{ width: "100%", display: "flex", flexDirection: "row", paddingLeft: "10px", marginTop: "10px" }}>
        <InputComponentV2 title={translate("City")} width="250px" value={emergencyContactCity} onChange={handleEmergencyContactCityChange} />
      </div>
      <div style={{ display: "flex", flexDirection: "column", gap: "20px", marginLeft: "10px", marginRight: "20px", marginTop: "10px" }}>
        <DropDownComponentV2 api="nationalities" title={translate("Nationality")} value={emergencyContactNationality} onChange={handleEmergencyContactNationalityChange} width="250px" />
      </div>
      <div style={{ display: "flex", flexDirection: "column", gap: "20px", marginLeft: "10px", marginRight: "20px", marginTop: "10px" }}>
        <InputComponentV2 title={translate("StateProvince")} width="250px" value={provinceEmergencyContact} onChange={handleProvinceEmergencyContactChange} />
      </div>
      <div style={{ display: "flex", flexDirection: "column", gap: "20px", marginLeft: "10px", marginRight: "20px", marginTop: "10px" }}>
        <DropDownComponentSortedV2 api="countries" title={translate("Country")} value={emergencyContactCountry} onChange={handleEmergencyContactCountryChange} width="250px" />
      </div>
      <div style={{ display: "flex", flexDirection: "column", gap: "20px", marginLeft: "10px", marginRight: "20px", marginTop: "10px" }}>
        <InputComponentV2 title={translate("PersonPayingForTreatment")} width="250px" value={payerName} onChange={handlePayerNameChange} />
      </div>
      <div style={{ display: "flex", flexDirection: "column", gap: "20px", marginLeft: "10px", marginRight: "20px", marginTop: "10px", marginBottom: "100px" }}>
        <PhoneNumberInput title={translate("PhoneNumberOfPersonPaying")} value={payerPhoneNumber} onChange={handlePayerPhoneNumberChange} />
      </div>
    </div>
  );
}

export default GeneralInformationV2EmergencySection;
